/* @flow */
import liferay from 'services/api';
import appActions from './app';
import type {
  Action,
  AsyncAction,
  CartItem,
  MergedLicenseComponent,
  SimplifiedTrack,
  WorklistItem,
} from '../../types';

const onFailure = (error: Object) => console.warn(error);

const fetchCartItems = (): AsyncAction => {
  //$FlowFixMe
  return {
    type: 'FIND_CART_ITEMS_REQUEST',
    promise: liferay.cart.items.find(),
    meta: { onFailure },
  };
};

const createCartItemsFromWorklistItems = (worklistItems: WorklistItem[]): AsyncAction => {
  //$FlowFixMe
  return {
    type: 'CREATE_CART_ITEMS_REQUEST',
    payload: worklistItems,
    promise: liferay.cart.items.create(worklistItems),
    meta: { onFailure, successMessage: 'Tracce aggiunte al carrello' },
  };
};

const createCartItemsFromTracks = (tracks: SimplifiedTrack[]): Action =>
  appActions.notImplemented();

const deleteCartItems = (cartItems: CartItem[]): AsyncAction => {
  //$FlowFixMe
  return {
    type: 'DELETE_CART_ITEMS_REQUEST',
    payload: cartItems,
    promise: liferay.cart.items.delete(cartItems),
    meta: { onFailure, successMessage: 'Tracce rimosse dal carrello' },
  };
};

const buyCartItems = (cartItems: CartItem[]): AsyncAction => {
  //$FlowFixMe
  return {
    type: 'BUY_CART_ITEMS_REQUEST',
    payload: cartItems,
    promise: liferay.cart.items.buy(cartItems),
    meta: { onFailure, successMessage: 'Tracce acquistate' },
  };
};

const selectAllCartItems = (): Action => {
  return {
    type: 'SELECT_ALL_CART_ITEMS',
  };
};

const deselectAllCartItems = (): Action => {
  return {
    type: 'DESELECT_ALL_CART_ITEMS',
  };
};

const toggleSelectAllCartItems = (): Action => {
  return {
    type: 'TOGGLE_SELECT_ALL_CART_ITEMS',
  };
};

const toggleSelectCartItem = (cartItemId: $PropertyType<CartItem, 'id'>): Action => {
  return {
    type: 'TOGGLE_SELECT_CART_ITEM',
    payload: cartItemId,
  };
};

const toggleSelectCartItemComponent = (
  cartItemId: $PropertyType<CartItem, 'id'>,
  componentId: $PropertyType<MergedLicenseComponent, 'id'>
): Action => {
  return {
    type: 'TOGGLE_SELECT_CART_ITEM_COMPONENT',
    payload: {
      cartItemId,
      componentId,
    },
  };
};

export default {
  fetchCartItems,
  createCartItemsFromTracks,
  createCartItemsFromWorklistItems,
  deleteCartItems,
  buyCartItems,
  selectAllCartItems,
  deselectAllCartItems,
  toggleSelectAllCartItems,
  toggleSelectCartItem,
  toggleSelectCartItemComponent,
};
